module.exports = __webpack_public_path__ + "img/dashboard-bg.5ea5db8d.png";